import Masonry from 'masonry-layout';

let masonryInstances = new Map(); // Store Masonry instances for each grid

export function cardSectionGridSlider() {
  $('.cards-section.grid.mobile-slider').each(function () {
    const grid = $(this).find('.cards-wrp')[0]; // Get the wrapper inside each section
    const isMobile = matchMedia('screen and (max-width: 767px)').matches;

    if (isMobile) {
      $(grid).addClass('flickity-class').removeClass('masonry-active');

      // Destroy Masonry instance safely
      if (masonryInstances.has(grid)) {
        masonryInstances.get(grid).destroy();
        masonryInstances.delete(grid);
      }

      setTimeout(() => {
        $(grid).flickity({
          pageDots: false,
          prevNextButtons: true,
          wrapAround: true,
          watchCSS: true,
        });
      }, 500);
    } else {
      $(grid).removeClass('flickity-class').addClass('masonry-active');

      setTimeout(() => {
        // Initialize Masonry only if it doesn't already exist
        if (!masonryInstances.has(grid)) {
          const masonry = new Masonry(grid, {
            itemSelector: '.cards-item-wrp',
            columnWidth: '.cards-item-wrp',
            horizontalOrder: true,
            gutter: 0,
          });

          masonryInstances.set(grid, masonry);
        } else {
          masonryInstances.get(grid).reloadItems();
          masonryInstances.get(grid).layout();
        }
      }, 500);
    }
  });

  $('.cards-section.grid:not(.mobile-slider)').each(function () {
    const grid = $(this).find('.cards-wrp')[0]; // Get the wrapper inside each section
    $(grid).addClass('masonry-active');

    setTimeout(() => {
      // Initialize Masonry only if it doesn't already exist
      if (!masonryInstances.has(grid)) {
        const masonry = new Masonry(grid, {
          itemSelector: '.cards-item-wrp',
          columnWidth: '.cards-item-wrp',
          horizontalOrder: true,
          gutter: 0,
        });

        masonryInstances.set(grid, masonry);
      } else {
        masonryInstances.get(grid).reloadItems();
        masonryInstances.get(grid).layout();
      }
    }, 500);
  });
}
